import { OnDestroy } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { CommonService } from 'src/app/services/common.service';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { ReportsService } from '../../services/reports.service';

@Component({
  selector: 'login-logout-notification-badge',
  templateUrl: './login-logout-notification-badge.component.html',
  styleUrls: ['./login-logout-notification-badge.component.scss'],
})
export class LoginLogoutNotificationBadgeComponent implements OnInit, OnDestroy {
  canSeeLoginLogoutNotifications: boolean = false;

  private _loginLogoutNotificationSubscription: Subscription;

  constructor(public cService: CommonService, private translate: TranslateService, public rptService: ReportsService) {}

  ngOnInit(): void {
    this.canSeeLoginLogoutNotifications = true;
    /*
    * May be added later. For now set to true
    this.cService.userProfile.company === 'amzl audits' ||
    this.cService.userProfile.company === 'eDriving';
    */

    if (this.canSeeLoginLogoutNotifications) {
      this._loginLogoutNotificationSubscription = this.rptService
        .sendLoginLogoutCountRequest('reports/driver/trips/total')
        .subscribe({
          next: (response) => {
            if (response) {
              this.rptService.loginLogoutNotificationsCount = response.total;
            }
          },
          error: (error) => console.log(error),
        });
    }
  }

  ngOnDestroy() {
    if (this._loginLogoutNotificationSubscription) {
      this._loginLogoutNotificationSubscription.unsubscribe();
    }
  }
}
